import { render, staticRenderFns } from "./homepage-takeover.vue?vue&type=template&id=470cc922&scoped=true&"
import script from "./homepage-takeover.vue?vue&type=script&lang=js&"
export * from "./homepage-takeover.vue?vue&type=script&lang=js&"
import style0 from "./homepage-takeover.vue?vue&type=style&index=0&id=470cc922&lang=scss&scoped=true&"
import style1 from "./homepage-takeover.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470cc922",
  null
  
)

export default component.exports